(function () {
    'use strict';

    angular
        .module('app.salespoints')
        .controller('SalespointsEditController', EditController);

    EditController.$inject = ['$location', '$stateParams', 'SalespointsService', 'Upload'];

    function EditController($location, $stateParams, Service, Upload) {
        /* jshint validthis:true */
        var vm = this;

        vm.loading = true;
        vm.title = '';

        Service.get($stateParams.SalespointId).then(function (data) {
            vm.entity = data;
            vm.loading = false;
        });

        vm.fields = Service.getFields();

        vm.edit = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                vm.entity.Media = null;
                Service.edit(vm.entity).then(function () {
                    vm.loading = false;
                    $location.path('/salespoints/detail/' + vm.entity.Id);
                });
            }
        };
    }
})();